/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/


import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TimelineHistory from '../../../../../../components/ui-elements/timeline/TimelineHistory';
import { Typography } from '@mui/material';
import { getDeviceHistory } from '../../../../../../store/reducers/device/deviceAction';

const DeviceHistory = ({ selectedDevice }) => {
    const [historyList, setHistoryList] = useState([]);
    const deviceHistory = useSelector(state => state.device.deviceHistory);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(getDeviceHistory({ "deviceID": selectedDevice.deviceID }));
    }, [dispatch, selectedDevice]);
    useEffect(() => {
        setHistoryList([])
        if (deviceHistory?.length > 0) {
            deviceHistory.forEach(element => {
                setHistoryList(item => [...item, {
                    ...element, Record: {
                        name: element.Record?.deviceName,
                        details: element.Record?.deviceDetails,
                        createdBy: element.Record?.createdBy,
                        updatedBy: element.Record?.updatedBy

                    }
                }])
            });
        }
    }, [deviceHistory]);

    return (
        <>
            <Typography variant="h3" align="center" color="success.light">Device  History</Typography>
            <TimelineHistory items={historyList} />
        </>
    )

}


export default DeviceHistory;